import ReactSelect from '../ReactSelect';
import React from 'react';
import StatusChip from '../Status/StatusChip';

export const hazardLevelOptions = [
  {
    value: 'HIGH',
    label: 'High',
  },
  {
    value: 'LOW',
    label: 'Low',
  },
] as const;

export type HazardLevel = (typeof hazardLevelOptions)[number]['value'];
export type MultiOnChange = (value?: HazardLevel[]) => void;
export type OnChange = (value?: HazardLevel) => void;
export const HazardLevelPicker = <IsMulti extends boolean = false>({
  value,
  onChange,
  isMulti,
  isClearable = false,
}: {
  isMulti?: IsMulti;
  onChange: IsMulti extends true ? MultiOnChange : OnChange;
  value?: IsMulti extends true ? HazardLevel[] : HazardLevel;
  isClearable?: boolean;
}) => {
  return (
    <ReactSelect
      placeholder="hazard level"
      isMulti={isMulti}
      isClearable={isClearable}
      menuPortalTarget={document.body}
      value={
        isMulti
          ? hazardLevelOptions.filter((option) => value?.includes(option.value))
          : hazardLevelOptions.find((option) => value === option.value)
      }
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '100px',
        }),
      }}
      formatOptionLabel={(hazardLevel) => (
        <StatusChip status={hazardLevel.value === 'HIGH' ? 'error' : 'warning'}>
          {hazardLevel.value}
        </StatusChip>
      )}
      onChange={(values) => {
        if (isMulti) {
          (onChange as MultiOnChange)(
            Array.isArray(values)
              ? values.length > 0
                ? values.map((value1) => value1.value as HazardLevel)
                : undefined
              : undefined
          );
        } else {
          const value =
            (values as (typeof hazardLevelOptions)[number])?.value ?? undefined;
          (onChange as OnChange)(value);
        }
      }}
      options={hazardLevelOptions}
    />
  );
};
